import * as React from "react"

import { Svg } from "styleguide/components"
import { SvgIconProps } from "styleguide/components/Svg/SvgIcon/SvgIcon"
import { uiColorToBaseColor } from "styleguide/styles/colors"

const IconBreadcrumbsArrow = ({
  title = "Arrow",
  color = "gray",
  viewBoxWidth = 4,
  viewBoxHeight = 6,
  ...otherProps
}: SvgIconProps) => (
  <Svg.Icon {...{ title, viewBoxHeight, viewBoxWidth, ...otherProps }}>
    <path
      d="M0 1l1-1 3 3-3 3-1-1 2-2z"
      fill={uiColorToBaseColor(color)}
      fillRule="evenodd"
    />
  </Svg.Icon>
)

export default IconBreadcrumbsArrow
